import { useState } from "react";
import { authFetch } from "../api/api";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const initialForm = {
  username: "",
  password: "",
  full_name: "",
  email: "",
  group_ids: [],
};

export default function UserFormModal({ groups, onClose, onCreated }) {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState(null);

  const setField = (key, value) =>
    setForm((prev) => ({ ...prev, [key]: value }));

  const toggleGroup = (id) => {
    setForm((prev) => {
      const has = prev.group_ids.includes(id);
      return {
        ...prev,
        group_ids: has
          ? prev.group_ids.filter((g) => g !== id)
          : [...prev.group_ids, id],
      };
    });
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setErrors(null);
    try {
      const res = await authFetch(`${BASE_URL}/api/users/register/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setErrors(data);
        return;
      }
      onCreated(data);
    } catch (err) {
      setErrors({ detail: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="user-modal__backdrop" onClick={onClose}>
      <div className="user-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Новый пользователь</h2>
        <form onSubmit={submit} className="user-modal__form">
          <label>
            Логин
            <input
              type="text"
              value={form.username}
              onChange={(e) => setField("username", e.target.value)}
              required
            />
          </label>

          <label>
            Пароль
            <input
              type="password"
              value={form.password}
              onChange={(e) => setField("password", e.target.value)}
              required
              minLength={8}
            />
          </label>

          <label>
            ФИО
            <input
              type="text"
              value={form.full_name}
              onChange={(e) => setField("full_name", e.target.value)}
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              value={form.email}
              onChange={(e) => setField("email", e.target.value)}
            />
          </label>

          <fieldset className="user-modal__groups">
            <legend>Группы</legend>
            {groups.length === 0 && (
              <p className="user-modal__hint">Групп в системе нет</p>
            )}
            {groups.map((g) => (
              <label key={g.id} className="user-modal__group">
                <input
                  type="checkbox"
                  checked={form.group_ids.includes(g.id)}
                  onChange={() => toggleGroup(g.id)}
                />
                {g.name}
              </label>
            ))}
          </fieldset>

          {errors && (
            <div className="user-modal__error">
              {Object.entries(errors).map(([k, v]) => (
                <div key={k}>
                  <strong>{k}:</strong>{" "}
                  {Array.isArray(v) ? v.join(", ") : String(v)}
                </div>
              ))}
            </div>
          )}

          <div className="user-modal__actions">
            <button type="button" onClick={onClose} disabled={submitting}>
              Отмена
            </button>
            <button type="submit" disabled={submitting}>
              {submitting ? "Создание…" : "Создать"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}